<div class="observe-section mt-0">
  <h1 class="section-title-observe mb-2">{{ 'EVALUATION.STATISTICAL_EVALUATION' | translate }}</h1>
  <p class="col-sm-12 col-md-9 pb-3 static-card-desc pl-0">{{ 'EVALUATION.CONSUMPTION.STATISTICAL_DESCRIPTION' | translate }}
  </p>
  <div class="row col p-0">
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'totalConsumption'})">
        <h1 class="section-title menuLink">{{'EVALUATION.CONSUMPTION.TOTAL_CONSUMPTION_TITLE' | translate }}</h1>
        <p>
          {{'EVALUATION.CONSUMPTION.TOTAL_CONSUMPTION_DESCRIPTION' | translate}}
        </p>
      </div>
    </div>
    <div class="col-sm-12 col-md-6 pr-0 d-flex">
      <div class=" static-card cursor" (click)="emitData({key:'consumptionPerPatient'})">
        <h1 class="section-title menuLink">{{ 'EVALUATION.CONSUMPTION.CONSUMPTION_PER_PATIENT_TITLE' | translate }}</h1>
        <p>
          {{'EVALUATION.CONSUMPTION.CONSUMPTION_PER_PATIENT_DESCRIPTION' | translate}}
        </p>
      </div>
    </div>
  </div>
</div>